import { Form, Input, Button, Card, Typography, Space, Alert } from 'antd'
import { MailOutlined, LockOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const { Title, Text } = Typography

interface LoginFormValues {
  email: string
  password: string
}

const LoginPage = () => {
  const { login, isLoginLoading, loginError } = useAuth()
  const [form] = Form.useForm()

  const handleSubmit = (values: LoginFormValues) => {
    login(values)
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f9fafb',
        padding: '48px 16px',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={2} style={{ margin: 0, color: '#111827' }}>
              Sign in to ThiranAi
            </Title>
            <Text style={{ color: '#6b7280', fontSize: '14px' }}>
              Your AI-powered RAG platform
            </Text>
          </div>

          {loginError && (
            <Alert
              message={loginError instanceof Error ? loginError.message : 'Login failed'}
              type="error"
              showIcon
              style={{ marginBottom: 16 }}
            />
          )}

          <Form
            form={form}
            name="login"
            onFinish={handleSubmit}
            layout="vertical"
            requiredMark={false}
            autoComplete="off"
          >
            <Form.Item
              name="email"
              label="Email address"
              rules={[
                { required: true, message: 'Please input your email!' },
                { type: 'email', message: 'Please enter a valid email!' },
              ]}
            >
              <Input
                prefix={<MailOutlined />}
                placeholder="Email address"
                size="large"
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Password"
                size="large"
                autoComplete="current-password"
              />
            </Form.Item>

            <div style={{ marginBottom: '16px', textAlign: 'right' }}>
              <Link to="/forgot-password" style={{ color: '#13afe3', fontSize: '14px' }}>
                Forgot password?
              </Link>
            </div>

            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={isLoginLoading}
                style={{ width: '100%' }}
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center' }}>
            <Text>
              Don't have an account?{' '}
              <Link to="/register" style={{ color: '#13afe3', fontWeight: 500 }}>
                Sign up
              </Link>
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  )
}

export default LoginPage